import EpisodeLevelReportingCard from './EpisodeLevelReportingCard';

export default EpisodeLevelReportingCard;
